const releaseNotesErrors = {
  RELEASE_NOTES_NOT_FOUND: "RELEASE_NOTES_NOT_FOUND"
};

export default releaseNotesErrors;
